import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CoreApiService } from "src/app/core/core-api.service";
import { IResult } from "src/app/shared/interface/result.interface";
import { endpoints } from "src/environments/endpoints";

import {
  IDecendio,
  IInstituicao,
  IPosicoes,
} from "../interface/relatorio-pagamento.interface";

@Injectable({
  providedIn: "root",
})
export class RelatorioPagamentoDecendialService {
  constructor(private coreApiService: CoreApiService) {}

  listarInstituicoes(params = {}): Observable<IResult<IInstituicao[]>> {
    return this.coreApiService.get(endpoints.getInstituicoes, { params });
  }

  listarRelatorioPagamento(params = {}): Observable<IResult<IInstituicao[]>> {
    return this.coreApiService.get(endpoints.listarRelatorioDecendio, {
      params,
    });
  }

  listarDecendios(params = {}): Observable<IResult<any[]>> {
    return this.coreApiService.get(endpoints.listarDecendios, { params });
  }

  listarExportacao(params = {}) {
    return this.coreApiService.get(endpoints.exportacaoPagamentos, { params });
  }
}
